import React, { useState } from "react"
import * as styles from "./SupplierDetails.module.scss"
import { OutboundLink } from "@lib/gtag"
import { eventGtag } from "@lib/gtag"
import SocialLinks from "@components/global/SocialLinks/SocialLinks"
import Button from "@components/objects/Button/Button"
import Section from "@components/structure/Section/Section"
import addressIcon from "@images/icons/addressIconDark.svg"

const ContactItem = (props) =>
  props.text ? (
    <div className={styles.ContactItem}>
      <img src={props.icon} alt="" />
      <span onClick={props.trackClick}>
        <OutboundLink href={props.link} target="_blank" rel="noopener noreferrer">
          {props.text}
        </OutboundLink>
      </span>
    </div>
  ) : null

const SupplierContact = (props) => {
  const handleClick = (name) => {
    eventGtag({
      action: "Click",
      params: {
        event_category: name,
        event_label: props.supplierName,
        value: props.supplierId,
      },
    })
  }

  const [showDetails, setShowDetails] = useState(true)

  const { data, facebook, twitter, instagram, linkedin } = props

  const { addressstreet1, addressstreet2, addresspostcode, addresscity, discount, website, phone } = data

  const address = addressstreet1
    ? `${addressstreet1}, ${addressstreet2 ? `${addressstreet2}, ` : ""}${addresscity} ${addresspostcode}`
    : null

  const hasDiscount = discount && discount !== "0%"

  const hasData = phone || website || addressstreet1 || facebook || twitter || instagram || linkedin

  return hasData ? (
    <Section
      id="contact"
      inner
      className={`${styles.borderTop} ${styles.SupplierContact} ${showDetails ? styles.active : ""}`}
    >
      <Button
        className={styles.showDetailsButton}
        text="Show Details"
        onClick={() => {
          setShowDetails(true)
          handleClick("showContact")
        }}
      />

      <div className={styles.contact}>
        <div className={styles.contactDetails}>
          <ContactItem
            trackClick={() => handleClick("Supplier Address")}
            name="Supplier Address"
            icon={addressIcon}
            link={`https://www.google.com/maps/search/?api=1&query=${address}`}
            text={address}
          />
        </div>
        <SocialLinks
          className={styles.links}
          trackClick={handleClick}
          facebook={facebook}
          twitter={twitter}
          instagram={instagram}
          linkedin={linkedin}
        />
      </div>
    </Section>
  ) : null
}

export default SupplierContact
